module.exports = __webpack_public_path__ + "media/images/hand-66c1a304bf0c59bafa488cfeb1cccf2f.jpg";